import React from "react";
import trackAnalyzeImg from "../../assets/Track and analyze.png";

function TrackAnalyzeSection() {
  return (
    <section className="bg-[#f5f5f5] py-16 lg:py-24">
      <div className="mx-auto grid max-w-[1300px] items-center gap-12 px-6 lg:grid-cols-2">
        <div className="flex justify-center">
          <img
            src={trackAnalyzeImg}
            alt="Track and Analyze"
            className="w-full max-w-[500px] object-contain"
          />
        </div>

        <div>
          <h2 className="text-4xl font-bold leading-tight text-[#111] lg:text-5xl">
            Track and analyze.
            <br />
            Optimize efficiency and profits!
          </h2>

          <p className="mt-6 text-[17px] leading-8 text-gray-600">
            Veyonta Track has always been at the forefront of designing robust
            GPS vehicle tracking systems. We help fleet management companies
            monitor performance, simplify operations and increase efficiency.
          </p>

          <p className="mt-5 text-[17px] leading-8 text-gray-600">
            Get started with intelligent tracking solutions and drive your
            business forward with our AIS-140 certified vehicle GPS tracker
            system.
          </p>
        </div>
      </div>
    </section>
  );
}

export default TrackAnalyzeSection;